import { GetAppParameter, UpdateAppParameter } from "./actionTypes";
import { Dispatch, AnyAction } from "redux";
import API from '../../services/requestService';
import { showLoader, showToast } from "./common";
import ENDPOINT from "../../services/endpoints";
import { TOAST_HEADER, MESSAGES } from "../../services/constants";
import { IAppParameter } from "../../shared/models/appParameterModel";


export const getAppParamters = () => async (dispatch: Dispatch<any>) => {
    dispatch(showLoader(true));
    try {
        const { data: response } = await API.get(ENDPOINT.siteConfigList);
        dispatch(showLoader(false));
        response.isSuccess ?
            dispatch({ type: GetAppParameter, payload: response.data }) :
            dispatch(showToast(TOAST_HEADER.ERROR, response.message));

    } catch (error) {
        console.error(error);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    }
}

export const updateAppParamters = (hours: number, appParameter: any) => (dispatch: Dispatch<AnyAction>) => (
    dispatch({ type: UpdateAppParameter, payload: { hours, appParameter } })
);

export const saveAppParameters = (params: IAppParameter[]) => async (dispatch: Dispatch<any>) => {
    dispatch(showLoader(true));
    // Post api to save config
    try {
        const { data: response } = await API.post(ENDPOINT.manageSiteConfigList, params)
        dispatch(showLoader(false));
        dispatch(showToast(response.isSuccess ? TOAST_HEADER.SUCCESS : TOAST_HEADER.ERROR, response.message));
    } catch (e) {
        console.error(e);
        dispatch(showLoader(false));
        dispatch(showToast(TOAST_HEADER.ERROR, MESSAGES.common));
    }
};
